<template>
  <v-main>
    <v-container fluid>
      <v-card elevation="6" rounded="xxl">
        <v-card-title class="mt-4">
          <v-btn
            class="mx-2"
            fab
            x-small
            color="primary"
            @click="$router.back()"
          >
            <v-icon dark>mdi-arrow-left</v-icon>
          </v-btn>
          Add Gift Catalogs
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col sm="4">
              <v-autocomplete
                ref="Positions"
                outlined
                v-model="form.position_id"
                :items="positionItems"
                label="Positions"
                prepend-inner-icon="mdi-arrow-expand-all"
                clearable
                :error-messages="errors.position_id"
              ></v-autocomplete>
            </v-col>
          </v-row>
          <div v-for="(level, index) in form.giftCatalog" :key="index">
            <v-row>
              <!-- Header with Delete Button -->
              <v-col cols="12" class="d-flex align-center">
                <h4 class="mr-2">Level {{ index + 1 }}</h4>
                <v-btn
                  v-if="form.giftCatalog.length > 1"
                  icon
                  color="red"
                  @click="removeLevel(index)"
                >
                  <v-icon>mdi-delete</v-icon>
                </v-btn>
              </v-col>

              <!-- Name Field -->
              <v-col sm="4">
                <v-text-field
                  v-model="level.name"
                  label="Name"
                  outlined
                  :error-messages="errors[`giftCatalog.${index}.name`] || []"
                ></v-text-field>
              </v-col>

              <!-- File Upload and Preview -->
              <v-col sm="4">
                <input
                  type="file"
                  :ref="'file_' + index"
                  @change="onFileChange($event, index)"
                  class="mb-2"
                />
                <v-btn
                  x-small
                  color="red"
                  dark
                  class="my-3"
                  @click="removeImage(index)"
                >
                  Remove
                </v-btn>
                <div v-if="level.image_path" class="mt-4">
                  <label>Image Preview</label><br />
                  <img
                    :src="level.image_path"
                    style="height: 200px; width: 380px"
                  />
                </div>
              </v-col>

              <!-- Points Field -->
              <v-col sm="4">
                <v-text-field
                  v-model="level.points"
                  label="Points"
                  outlined
                  :error-messages="errors[`giftCatalog.${index}.points`] || []"
                ></v-text-field>
              </v-col>

              <!-- Amount Field -->
              <v-col sm="4">
                <v-text-field
                  v-model="level.amount"
                  label="Amount (₹)"
                  outlined
                  type="number"
                  step="0.01"
                  min="0"
                  :error-messages="errors[`giftCatalog.${index}.amount`] || []"
                ></v-text-field>
              </v-col>

              <!-- HSN Code Field -->
              <v-col sm="4">
                <v-text-field
                  v-model="level.hsn_code"
                  label="HSN Code"
                  outlined
                  maxlength="20"
                  :error-messages="errors[`giftCatalog.${index}.hsn_code`] || []"
                ></v-text-field>
              </v-col>
            </v-row>

            <!-- Dimensions Row -->
            <v-row>
              <v-col cols="12">
                <h5 class="text-subtitle-1 mb-2">Shipping Dimensions</h5>
              </v-col>
              
              <!-- Width Field -->
              <v-col sm="3">
                <v-text-field
                  v-model="level.width"
                  label="Width (cm)"
                  outlined
                  type="number"
                  step="0.01"
                  min="0"
                  :error-messages="errors[`giftCatalog.${index}.width`] || []"
                ></v-text-field>
              </v-col>

              <!-- Height Field -->
              <v-col sm="3">
                <v-text-field
                  v-model="level.height"
                  label="Height (cm)"
                  outlined
                  type="number"
                  step="0.01"
                  min="0"
                  :error-messages="errors[`giftCatalog.${index}.height`] || []"
                ></v-text-field>
              </v-col>

              <!-- Length Field -->
              <v-col sm="3">
                <v-text-field
                  v-model="level.length"
                  label="Length (cm)"
                  outlined
                  type="number"
                  step="0.01"
                  min="0"
                  :error-messages="errors[`giftCatalog.${index}.length`] || []"
                ></v-text-field>
              </v-col>

              <!-- Weight Field -->
              <v-col sm="3">
                <v-text-field
                  v-model="level.weight"
                  label="Weight (grams)"
                  outlined
                  type="number"
                  step="0.001"
                  min="0"
                  :error-messages="errors[`giftCatalog.${index}.weight`] || []"
                ></v-text-field>
              </v-col>
            </v-row>
          </div>
          <v-btn class="mt-2 mb-4" color="secondary" @click="addLevel">
            <v-icon left>mdi-plus</v-icon>
            Add Next Level
          </v-btn>

          <v-divider class="my-5"></v-divider>

          <v-btn
            rounded
            color="primary"
            :loading="isLoading"
            :disabled="isLoading"
            @click="save"
          >
            Save Gift Catalogs
          </v-btn>
        </v-card-text>
      </v-card>
    </v-container>
  </v-main>
</template>
<script>
import axios from "axios";
export default {
  name: "GiftCatalogCreatePage",
  data() {
    return {
      form: {
        position_id: "",
        giftCatalog: [
          {
            name: "",
            image_path: "",
            points: "",
            amount: "",
            hsn_code: "",
            width: "",
            height: "",
            length: "",
            weight: "",
          },
        ],
      },
      positionItems: [],
      isLoading: false,
    };
  },
  mounted() {
    this.getMasters();
  },
  methods: {
    async getMasters() {
      await axios
        .get(`gift_catalogs/masters`)
        .then((masters) => {
          masters = masters.data;
          //Gift Categories
          masters.positions.forEach((position) => {
            this.positionItems.push({
              id: position.id,
              text: position.name,
              value: position.id,
            });
          });
        })
        .catch(function (error) {
          console.log(error);
          // redirect to Home Page
          // window.location.href = "/auth/login";
        });
    },
    addLevel() {
      this.form.giftCatalog.push({
        name: null,
        image_path: null,
        points: null,
        amount: null,
        hsn_code: null,
        width: null,
        height: null,
        length: null,
        weight: null,
      });
    },
    removeLevel(index) {
      this.form.giftCatalog.splice(index, 1);
    },
    onFileChange(event, index) {
      const file = event.target.files[0];
      if (file) {
        this.form.giftCatalog[index].file = file;
        // this.form.giftCatalog[index].image_path = URL.createObjectURL(file);
        this.form.giftCatalog[index].image_path = file;
      }
    },
    removeImage(index) {
      this.$refs["file_" + index][0].value = null;
      this.form.giftCatalog[index].image_path = null;
    },
    async save() {
      console.log("giftCatalog", this.form.giftCatalog);
      let formData = new FormData();
      // Append scalar values
      formData.append("position_id", this.form.position_id);
      // formData.append("giftCatalog", this.form.giftCatalog);

      // Loop over giftCatalog items
      this.form.giftCatalog.forEach((level, index) => {
        formData.append(`giftCatalog[${index}][name]`, level.name);
        formData.append(`giftCatalog[${index}][points]`, level.points);
        
        // Append amount if provided
        if (level.amount) formData.append(`giftCatalog[${index}][amount]`, level.amount);

        // Append HSN code if provided
        if (level.hsn_code) formData.append(`giftCatalog[${index}][hsn_code]`, level.hsn_code);

        // Append dimensions if provided
        if (level.width) formData.append(`giftCatalog[${index}][width]`, level.width);
        if (level.height) formData.append(`giftCatalog[${index}][height]`, level.height);
        if (level.length) formData.append(`giftCatalog[${index}][length]`, level.length);
        if (level.weight) formData.append(`giftCatalog[${index}][weight]`, level.weight);

        // Append the actual file
        if (level.image_path instanceof File) {
          console.log("level.image_path", level.image_path);
          formData.append(
            `giftCatalog[${index}][image_path]`,
            level.image_path
          );
        }
      });

      try {
        this.isLoading = true;
        await axios.post("/gift_catalogs", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });
        await this.saveUserTimestamp(null, this.form);
        this.isLoading = false;
        this.$router.back();
      } catch (e) {
        console.error(e);
        this.isLoading = false;
      }
    },

    // async save() {
    //   let formData = new FormData();
    //   formData.append("giftCatalog", this.form.giftCatalog);
    //   formData.append("position_id", this.form.position_id);
    //   try {
    //     this.isLoading = true;
    //     await axios.post("/gift_catalogs", formData, {
    //       headers: {
    //         "Content-Type": "multipart/form-data",
    //       },
    //     });
    //     await this.saveUserTimestamp(null, this.form);
    //     this.isLoading = false;
    //     this.$router.back();
    //   } catch (e) {
    //     // alert("error");
    //     console.log(e);
    //     this.isLoading = false;
    //   }
    // },
  },
};
</script>
